import { loginRequest } from "./authConfig";
import { msalInstance } from "./../index";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
const graphApiUrl = "https://graph.microsoft.com/v1.0";

export interface IAzureUser {
  id: string;
  displayName: string;
  mail?: string;
  country?: string;
  department?: string;
  updatedDate: string;
}

export const fetchMeInfo = async (): Promise<IAzureUser> => {
  try {
    const account = msalInstance.getActiveAccount();

    if (!account) {
      throw new Error("User not authentified...");
      //Logout
    }

    try {
      // Try acquiring token silently
      const tokenResponse = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });

      const accessToken = tokenResponse.accessToken;

      const response = await fetch(
        `${graphApiUrl}/me?$select=id,mail,displayName,country,department,updatedDate`, //jobTitle
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        // if (response.status === 401 || response.status === 403) {
        //   // Redirect to re-authenticate if necessary
        //   await msalInstance.acquireTokenRedirect(loginRequest);
        // }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const infosUser = await response.json();
      return infosUser;
    } catch (tokenError) {
      // Handle MFA expiration or other interaction-required errors
      if (tokenError instanceof InteractionRequiredAuthError) {
        // Re-authenticate using redirect (no popup)
        await msalInstance.acquireTokenRedirect(loginRequest);
        //return fetchMeInfo();
        window.location.href = "/home"; // Redirection without return
        return Promise.reject("Re-authentication required, redirecting..."); // Return here to avoid TypeScript error
      } else {
        throw tokenError;
      }
    }
  } catch (error) {
    if (!navigator.onLine) {
      //TODO: ask to fix internet connexion
    }
    console.error("Error while retrieving user information:", error);
    throw error;
  }
};
